import React from "react";
import Hero from "../components/Hero";
import HomeServicesPreview from "../components/HomeServicesPreview";
import HomePortfolioPreview from "../components/HomePortfolioPreview";
import HomeCTA from "../components/HomeCTA";

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <HomeServicesPreview />
      <HomePortfolioPreview />
      <HomeCTA />
    </>
  );
};

export default HomePage;
